import React from 'react';
import { ContextMenu as BaseContextMenu, ContextMenuItem } from './ContextMenu';

export interface MenuItem {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  danger?: boolean;
  type?: 'item' | 'header' | 'separator';
  icon?: React.ReactNode;
}

interface UnifiedContextMenuProps {
  x: number;
  y: number;
  items: MenuItem[];
  onClose: () => void;
}

export const UnifiedContextMenu: React.FC<UnifiedContextMenuProps> = ({
  x,
  y,
  items,
  onClose
}) => {
  return (
    <BaseContextMenu x={x} y={y} onClose={onClose}>
      {items.map((item, index) => {
        if (item.type === 'separator') {
          return <div key={`sep-${index}`} className="border-t border-gray-200/60 dark:border-gray-700/60 my-1"></div>;
        }
        
        if (item.type === 'header') {
          return (
            <div 
              key={`header-${index}`} 
              className="px-4 py-2 text-sm font-medium text-gray-500/80 dark:text-gray-400/80 bg-gray-50/50 dark:bg-gray-700/50 backdrop-blur-sm"
            >
              {item.label}
            </div>
          );
        }
        
        return (
          <ContextMenuItem
            key={`item-${index}`}
            label={item.label}
            onClick={item.onClick}
            disabled={item.disabled}
            danger={item.danger}
            icon={item.icon}
          />
        );
      })}
    </BaseContextMenu>
  );
};
